<nav id="footerid" class="footer-global">
    <div>
        <span class="footer-link-global float-left">Copyright &#64; 2022</span>
        
        <span class="footer-link-global float-right">PRIVACY POLICY</span>
        <span class="footer-link-separator float-right">|</span>
        <span class="footer-link-global float-right">CONTACT US</span>
        <span class="footer-link-separator float-right">|</span>
        <span class="footer-link-global float-right">TERMS OF USE</span>
        <!-- <span class="footer-link-separator float-right">|</span>
        <span class="footer-link float-right">FAQs</span> -->
    </div>
</nav>